import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment';

export default class reviewObj {

    constructor(data) {

        console.log("reviewObj: constructor");
        console.log(data);
        this.componentname = "reviewObj";

        //ReviewApprove Object
        this.reviewId = ko.observable(data.reviewId);
        this.data = ko.observable(data.data);
        this.jobid = ko.observable(data.jobid);
        this.guid = ko.observable(data.guid);
        this.sort = ko.observable(data.sort);
        this.jdmUserID = ko.observable(data.jdmUserID);
        this.role = ko.observable(data.role);
        this.statusid = ko.observable(data.statusid);
        this.status = ko.observable(data.status);
        this.startTime = ko.observable(data.startTime);
        this.endTime = ko.observable(data.endTime);
        this.statusCSS = ko.observable(data.class);
        this.notify = ko.observable(data.notify);

        this.displayReviewTimes = ko.computed( () => {

            if((this.startTime() != undefined) && (this.endTime() != undefined))
            {
                return true;
            }
            else
            {
                return false;
            }

        });

        this.startTimeFormated = ko.computed( arg => {

            console.log(this);

            if(this.startTime() != undefined)
            {
                return moment(this.startTime()).format('llll');
            }
            else
            {
                return "";
            }

        });

        this.endTimeFormated = ko.computed(arg => {
            
            if(this.endTime() != undefined)
            {
                return moment(this.endTime()).format('llll');
            }
            else
            {
                return "";
            }

        });

        this.elapsedTime = ko.computed( arg => {

            if((this.endTime() != undefined) && (this.startTime() != undefined))
            {
                let start = moment(this.startTime());
                let end = moment(this.endTime());
                console.log("reviewObj:constructor: elapsedTime: %o", moment.duration(start.diff(this.endTime())).humanize());
                return moment.duration(start.diff(this.endTime())).humanize();
            }
            else
            {
                return '';
            }

        });

        //Requied table
        this.subid = ko.observable(data.subid);
        this.subparentid = ko.observable(data.subparentid);
        this.partnerid = ko.observable(data.partnerid);

        //Partial JdmUser Object
        this.name = ko.observable(data.name);
        this.title = ko.observable(data.title);
        this.email = ko.observable(data.email);

    }

}

//export let  subTopicObj = new subTopicObjModel();


// WEBPACK FOOTER //
// ./src/objects/reviewObj.js